import './style.scss';

const BioPage = () => (
  <section className="bio">
    <div className="bio__title-wrapper">
      <p className="bio__title">Bio</p>
      <p className="bio__subtitle">Damon Nam</p>
    </div>
    <article className="bio__article">
      <div className="bio__text-block">
        <p className="bio__text">
          Damon is a technology executive and investor with more than 26 years of experience across enterprise technology and emerging innovation. After 17 years at Microsoft, he spent the past eight years helping companies navigate blockchain, fintech, and AI, working with organizations including Republic and Binance US. Today, he leads ventures including Majlis Capital and RobotMoney.
        </p>
      </div>
      <div className="bio__text-block">
        <p className="bio__text">
          During his 17 years at Microsoft, Damon held multiple leadership roles across the Microsoft Services organization. He worked directly with Fortune 1000 customers, supported field teams with delivery and resource strategy, and ultimately served as U.S. Services Program Director. In that role, he led the Preferred Services Partner program, managing approximately 75 partner organizations and more than $90 million in annual business.
        </p>
      </div>
      <div className="bio__text-block">
        <p className="bio__text">
          Damon studied Information Technology and has a Bachelor of Science in Business at Southern Methodist University. He has also been accepted into Entrepreneur Magazine’s Leadership Network and is a contributor and guest writer.
        </p>
      </div>
    </article>
  </section>
);

export default BioPage;
